import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Pagination} from "page/util/Pagination";

export default function RecommendationMain() {
    const [pager, setPager] = useState();
    const [results, setResults] = useState([]);
    const [consumerId, setConsumerId] = useState("");
    const [profileNo, setProfileNo] = useState("");
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [page, setPageState] = useState(1);

    const load = (nextPage = page) => {
        const params = {page: nextPage, size: 20};
        if (consumerId) params.consumerId = consumerId;
        if (profileNo) params.profileNo = profileNo;
        if (from) params.from = from;
        if (to) params.to = to;
        axios.get("/admin/v1/recommendation/traces", {params}).then(res => {
            setPager(res.data);
            setResults(res.data.content || []);
        });
    };

    useEffect(() => {
        load(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const search = () => {
        setPageState(1);
        load(1);
    };

    const downloadFile = async (url, fallbackName) => {
        const response = await axios.get(url, {responseType: "blob"});
        const blob = new Blob([response.data], {type: response.headers["content-type"] || "application/octet-stream"});
        const cd = response.headers && (response.headers["content-disposition"] || response.headers["Content-Disposition"]);
        let filename = fallbackName;
        if (cd) {
            const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd);
            if (match) {
                filename = decodeURIComponent(match[1] || match[2]);
            }
        }

        const link = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);
    };

    const downloadCsv = () => downloadFile("/admin/v1/recommendation/traces/export-csv", "tta_recommendation_metric_log.csv");
    const downloadXlsx = () => downloadFile("/admin/v1/recommendation/traces/export-xlsx", "tta_recommendation_metric_log.xlsx");

    const deleteAll = async () => {
        if (!window.confirm("TTA 로그를 모두 삭제하시겠습니까?")) return;

        try {
            const response = await axios.delete("/admin/v1/tta/logs");
            window.alert(`${response.data.deletedCount || 0}건의 TTA 로그를 삭제했습니다.`);
            setPageState(1);
            load(1);
        } catch (error) {
            window.alert("TTA 로그 삭제에 실패했습니다.");
        }
    };

    const openUserDetail = (userId) => {
        if (!userId) return;
        window.open(`/page/users/detail?userId=${userId}`, '_blank', 'noopener,noreferrer');
    };

    const parseProviderIds = (value) => {
        if (!value) return [];
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">TTA &gt; 추천 로그</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-flex justify-content-between align-items-start flex-wrap" style={{gap: 12}}>
                                        <div className="card-title mb-0">TTA &gt; 추천 로그</div>
                                        <div className="d-flex flex-wrap" style={{gap: 8}}>
                                            <button className="btn btn-success btn-sm" onClick={downloadCsv}>CSV 다운로드</button>
                                            <button className="btn btn-primary btn-sm" onClick={downloadXlsx}>엑셀 다운로드</button>
                                            <button className="btn btn-danger btn-sm" onClick={deleteAll}>전체 삭제</button>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap mt-3" style={{gap: 8}}>
                                        <input className="form-control" style={{width: 120}} placeholder="consumerId" value={consumerId} onChange={e => setConsumerId(e.target.value)} />
                                        <input className="form-control" style={{width: 100}} placeholder="profileNo" value={profileNo} onChange={e => setProfileNo(e.target.value)} />
                                        <input className="form-control" style={{width: 220}} placeholder="from (2026-06-17T00:00:00)" value={from} onChange={e => setFrom(e.target.value)} />
                                        <input className="form-control" style={{width: 220}} placeholder="to (2026-06-17T23:59:59)" value={to} onChange={e => setTo(e.target.value)} />
                                        <button className="btn btn-info btn-sm" style={{width: 90}} onClick={search}>검색</button>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0" style={{marginTop: 20, overflowX: "auto"}}>
                                    <table className="table table-hover" style={{textAlign: "center", tableLayout: "fixed", minWidth: 1400}}>
                                        <thead>
                                        <tr>
                                            <th style={{width: 180}}>로그 저장 시각</th>
                                            <th style={{width: 260}}>회차ID</th>
                                            <th style={{width: 110}}>프로필번호</th>
                                            <th style={{width: 120}}>구매자ID</th>
                                            <th style={{width: 180}}>벡터DB 시작 시각</th>
                                            <th style={{width: 180}}>추천 응답 완료 시각</th>
                                            <th style={{width: 120}}>소요시간(ms)</th>
                                            <th style={{width: 110}}>반환건수</th>
                                            <th style={{width: 320}}>판매자ID</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {results.map(item => (
                                            <tr key={`${item.sessionId}-${item.profileNo}-${item.createdAt}`}>
                                                <td style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{item.createdAt}</td>
                                                <td style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}} title={item.sessionId || ""}>{item.sessionId || '-'}</td>
                                                <td>{item.profileNo}</td>
                                                <td>
                                                    {item.consumerId ? (
                                                        <button className="btn btn-link p-0 align-baseline" onClick={() => openUserDetail(item.consumerId)}>
                                                            {item.consumerId}
                                                        </button>
                                                    ) : '-'}
                                                </td>
                                                <td style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{item.t1VectorDbStartAt}</td>
                                                <td style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{item.t2RecommendationResponseEndAt}</td>
                                                <td>{item.elapsedMs}</td>
                                                <td>{item.resultCount}</td>
                                                <td style={{whiteSpace: "pre-wrap", textAlign: "left", overflowWrap: "anywhere"}}>
                                                    {parseProviderIds(item.top5ProviderIdsJson).length === 0 ? (
                                                        item.top5ProviderIdsJson || '-'
                                                    ) : (
                                                        <div>
                                                            {parseProviderIds(item.top5ProviderIdsJson).map((providerId, index) => (
                                                                <div key={`${item.sessionId}-${item.profileNo}-${index}`}>
                                                                    <button className="btn btn-link p-0 align-baseline" onClick={() => openUserDetail(providerId)}>
                                                                        {providerId}
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {pager && <Pagination pager={pager} setPage={setPageState} />}
                    </section>
                </div>
            </div>
        </div>
    );
}
